module.exports = __webpack_public_path__ + "img/xiaomi-3.e9653c66.png";